<template>
  <div class="index">
    <!-- <div class="top">
      <img src="./assets/img-003.png" class="back-img" alt="" />
      <span>服务报表</span>
      <span></span>
    </div> -->
    <div class="nav">
      <div
        class="nav-list"
        :class="timeType == 1 ? 'active' : ''"
        @click="change(1)"
      >
        上周
      </div>
      <div
        class="nav-list"
        :class="timeType == 2 ? 'active' : ''"
        @click="change(2)"
      >
        上月
      </div>
      <div
        class="nav-list"
        :class="timeType == 3 ? 'active' : ''"
        @click="change(3)"
      >
        本月
      </div>
      <div
        class="nav-list"
        :class="timeType == 4 ? 'active' : ''"
        @click="change(4)"
      >
        近30天
      </div>
    </div>
    <div id="myChart"></div>
    <div class="date-lists">
      <div class="data-nav">
        <div class="date-list">日期</div>
        <div class="date-list">
          {{
            type == 1
              ? "违规率"
              : type == 2
              ? "已付款金额"
              : type == 3
              ? "已收款金额"
              : type == 4
              ? "待收款金额"
              : type == 5
              ? "在线时长"
              : type == 6
              ? "访问人数"
              : type == 7
              ? "新增粉丝"
              : type == 8
              ? "拍品数量"
              : type == 9
              ? "付款人数"
              : "消息回复率"
          }}
        </div>
        <div class="date-list">
          {{
            type == 1
              ? "客户接入率"
              : type == 2
              ? "笔数"
              : type == 3
              ? "笔数"
              : type == 4
              ? "笔数"
              : type == 5
              ? "观看人数"
              : type == 6
              ? "笔数"
              : type == 7
              ? "取关粉丝"
              : type == 8
              ? "拍品金额"
              : type == 9
              ? "新用户占比"
              : "客户接入率"
          }}
        </div>
      </div>
      <div class="date-con">
        <div class="date-con-list" v-for="(item, index) in data" :key="index">
          <span>{{ item.createTimeString }}</span>
<!--          <span>{{ item.money }}</span>-->
          <span>{{ type == 2 || type == 3 || type == 4 ? item.money +'万' : item.money }}</span>
          <span>{{ item.number }}</span>
        </div>
        <div class="date-con-list text-333">
          <span>小计</span>
          <span>{{ num }}</span>
          <span>{{ num2 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import qs from "qs";
import axios from "axios";
import config from "../config/config";
export default {
  data() {
    return {
      timeType: 1,
      data: [],
      type: 1,
      num: "",
      num2: "",
      token: "",
    };
  },
  mounted() {
    var url = window.location.href.split("=");
    var num = url.length;
    this.token = url[num - 1];
    var type = url[1].split("&");
    this.type = type[0];
    this.fetch();
  },
  methods: {
    change(index) {
      this.timeType = index;
      this.fetch();
    },
    fetch() {
      let aaa = qs.stringify({
        type: this.type,
        timeType: this.timeType,
      });

      axios.defaults.headers["Content-type"] =
        "application/x-www-form-urlencoded";
      axios.defaults.headers["token"] = this.token;
      // "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImNhNGUzZGFlLTgyZGUtNGFiNS05NWVmLTM0ZWNlMWJjNjVhZSJ9.cFT2xNJo0RLCiofTSZ9dPmikmuBaAw5zhlFAbCppNuT-GkP7ptkC_s3lSUEAwV5buZTIfoYdI3HQb2yTII1QbA";

      axios
        .post(
          config.url+"api/immediate/reportForm/list",
          aaa
        )
        .then((res) => {
          this.data = res.data.data.list;
          for (var i = 0; i < this.data.length; i++) {
            this.data[i].money = this.type == 2 || this.type == 3 || this.type == 4 ? this.data[i].money / 10000 : datas[i].money
          }
          this.num =this.type == 2 || this.type == 3 || this.type == 4? res.data.data.sumMoney/10000+'万':res.data.data.sumMoney;
          // this.num = res.data.data.sumMoney;
          this.num2 = res.data.data.sumNumber;
          this.aaa();
        });
    },
    aaa() {
      var chartDom = this.$echarts.init(document.getElementById("myChart"));
      var option;

      var datas = this.data; //
      var data = [];
      for (var i = 0; i < datas.length; i++) {
        data.push([
          new Date(datas[i].createTimeString).getTime(),
          datas[i].money,
        ]);
      }

      var x = [];
      for (var i = 0; i < datas.length; i++) {
        x.push(datas[i].createTimeString);
      }
      var y = [];
      for (var i = 0; i < datas.length; i++) {
        y.push(datas[i].money);
      }
      option = {
        tooltip: {
          trigger: "axis",
          // position: function (pt) {
          //   return [pt[0], "0%"];
          // },
          position: ['50%', '50%']
        },
        title: {
          left: "center",
          text:
            this.timeType == 1
              ? "上周报表"
              : this.timeType == 2
              ? "上月报表"
              : this.timeType == 3
              ? "本月报表"
              : "近30天报表",
          textStyle: {
            fontWeight: "normal",
            fontSize: 16,
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: x,
          splitLine: {
            lineStyle: { type: "dashed", color: "#fff" },
          },
          axisLine: {
            show: false,
          },

          axisTick: {
            show: false,
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          splitLine: {
            lineStyle: { type: "dashed" },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          splitArea: { show: false },
          axisLabel: {
            formatter: `{value}${this.type == 2 || this.type == 3 || this.type == 4?'万':''} `,
            align: "center"
          },
        },
        series: [
          {
            data: y, //[820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            // smooth: true,
            name:
              this.type == 1 ||
              this.type == 3 ||
              this.type == 4 ||
              this.type == 5
                ? "成交金额"
                : this.type == 2
                ? "已收款金额"
                : this.type == 6
                ? "访问数"
                : this.type == 7
                ? "新增人数"
                : this.type == 8
                ? "拍品数量"
                : "成交金额",
            symbol: "none",
            color: ["#FF5000"],
            backgroundColor: "rgba(0, 0, 0, 0.55)",
            areaStyle: {
              color: "#FFDCCC",
            },
          },
        ],
      };

      chartDom.setOption(option);
    },
  },
};
</script>

<style scoped>
.index {
  width: 100vw;
  overflow-x: hidden;
}
.text-333 span {
  color: #333 !important;
}
.text-333 {
  border-top: 1px solid #eee;
}
.data-nav {
  display: flex;
  border-top: 20px solid #f2f2f2;
  border-bottom: 1px solid #eeeeee;
}
.date-list {
  width: 33%;
  height: 45px;
  font-size: 15px;
  line-height: 45px;
  color: #333333;
}
.date-list:nth-of-type(1) {
  text-indent: 20px;
}
.date-con-list {
  display: flex;
}
.date-con-list span {
  width: 33%;
  font-size: 15px;
  color: #666666;
  height: 40px;
  line-height: 40px;
}
.date-con-list span:nth-of-type(1) {
  text-indent: 20px;
}
#myChart {
  width: 100%;
  height: 500px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.nav {
  display: flex;
  background: #f2f2f2;
  height: 40px;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
}
.nav-list {
  height: 39px;
  line-height: 39px;
}
.nav-list.active {
  color: #ff5000;
  font-weight: 500;
  border-bottom: 1px solid #ff5000;
}
.back-img {
  width: 10px;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
  padding: 0 10px;
  box-sizing: border-box;
  box-shadow: 1px 1px 0px 0px rgba(221, 221, 221, 0.44);
}
</style>



// WEBPACK FOOTER //
// src/chart.vue